//@flow
import React from 'react';
import FiltersActions from '../../Actions/filters';

function _clearFilters() {
  FiltersActions.clearFilters();
}

export default function FilterClear(props:{ children?:any }) {
  return (
    <span className="filter-clear" onClick={_clearFilters}>
      {props.children}
    </span>
  );
}
